import { Component, Input, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
   selector: 'app-sidebar-modules',
   templateUrl: './sidebar-modules.component.html',
   styleUrls: ['./sidebar-modules.component.scss'],
})
export class SidebarModulesComponent implements OnInit {
   @Input() item: any;
   currentRoute = '';
   currentCategory = '';

   constructor(public router: Router) {}

   ngOnInit() {
      this.router.events.subscribe((event: Event) => {
         if (event instanceof NavigationEnd) { 
            this.currentCategory = event.url.split('/')[1];
         }
      });
   }

   actionResponsive(event) {
      if(window.innerWidth <= 992) {
         const element = document.querySelector('.navbar-collapse');
         element?.classList.remove('show');
         const button = document.querySelector('.nav-responsive');
         button?.classList.remove('govco-times');
         button?.classList.add('govco-bars');
      }
      
      const body = document.getElementsByTagName('body');
      const expanded: any = event.target.getAttribute('aria-expanded');
      if (expanded == 'true') {
        body[0].classList.add('scrollNone');
      } else {
        body[0].classList.remove('scrollNone');
      }
   }
}
